jQuery(function ($) {
    jQuery(document).ready(function () {
        let warmAjaxObj;
        let searchCache = {};
        let warmedPrefixes = {};
        let lastResultsCount = 0;
        let latestSearchToken = 0;

        // REST API base URL
        const restBase = ThemeJS.Variables.Ajax.url.replace('wp-admin/admin-ajax.php', 'wp-json/elastic-integration/v1');
        const elasticSearchConfig = ThemeJS.Variables.ElasticSearch || {};
        const enableWarmJs = Boolean(elasticSearchConfig.enableWarmJs);
        const enableWarmApi = Boolean(elasticSearchConfig.enableWarmApi);
        const searchDebounceMs = Number(elasticSearchConfig.searchDebounceMs || 150);

        function debounce(func, delay) {
            let debounceTimer;
            return function () {
                const context = this;
                const args = arguments;
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => func.apply(context, args), delay);
            };
        }

        function renderSearchResults(data, query) {
            let html = '<div class="search-result-contain search-result-contain--products-only"><div class="search-result-options">';

            // if (data.collections && data.collections.length > 0) {
            //     html += '<div><h3>COLLECTIONS</h3><div class="search-result-option-list">';
            //     data.collections.forEach(c => {
            //         html += `<a href="${c.link}"><i class="fa-regular fa-magnifying-glass"></i> ${c.title}</a>`;
            //     });
            //     html += '</div></div>';
            // }

            // if (data.files && data.files.length > 0) {
            //     html += '<div class="files_section_search"><h3>FILES</h3><div class="search-result-option-list">';
            //     data.files.forEach(f => {
            //         html += `<a href="${f.link}"><i class="fa-regular fa-magnifying-glass"></i> ${f.title}</a>`;
            //     });
            //     html += '</div></div>';
            // }

            html += '<div class="search-result-list"><div>';

            if (data.products && data.products.length > 0) {
                html += '<div class="search-result-list-result">';
                data.products.forEach(p => {
                    html += `<a href="${p.link}" class="search-result-link" data-query="${encodeURIComponent(query)}" data-results="${data.total_results || 0}">`;
                    if (p.rebate) {
                        html += `<span class="rebate">${p.rebate}</span>`;
                    }
                    html += `<div class="search-result-list-result-image">${p.image}</div>`;
                    html += `<p class="result-title">${p.title || ''}</p>`;
                    html += `<p class="result-sku">SKU: ${p.sku || ''}</p>`;
                    html += `<p class="result-price">${p.price || ''}</p>`;
                    if (p.price_html) {
                        html += p.price_html;
                    }
                    html += `</a>`;
                });
                html += '</div>';
            } else {
                html += `<div class="no-result-data">Sorry, nothing found for ${query}</div>`;
            }



            // html += '<button type="submit" class="btn btn-desktop">VIEW ALL ITEMS &nbsp; <i class="fa-regular fa-arrow-right"></i> </button></div>';
            html += '</div><button type="submit" class="btn-primary new-btn btn">VIEW ALL ITEMS &nbsp; <i class="fa-regular fa-arrow-right"></i> </button></div></div>';

            return html;
        }

        function renderSkeletonScreen() {
            let html = '<div class="search-result-contain search-result-contain--products-only skeleton-contain">';
            html += '<div class="search-result-options">';

            // html += '<div><h3>COLLECTIONS</h3><div class="search-result-option-list">';
            // for (let i = 0; i < 3; i++) {
            //     html += '<div class="skeleton shimmer skeleton-line"></div>';
            // }
            // html += '</div></div>';

            // html += '<div class="files_section_search"><h3>FILES</h3><div class="search-result-option-list">';
            // for (let i = 0; i < 2; i++) {
            //     html += '<div class="skeleton shimmer skeleton-line"></div>';
            // }
            // html += '</div></div>';

            // html += '<div class="skeleton shimmer skeleton-btn"></div>';
            // html += '</div>'; // end search-result-options

            html += '<div class="search-result-list"><div>';
            html += '<div class="search-result-list-result">';
            for (let i = 0; i < 12; i++) {
                html += '<div class="search-result-link skeleton-product">';
                html += '<div class="skeleton shimmer skeleton-img"></div>';
                html += '<div class="skeleton shimmer skeleton-text" style="width: 80%"></div>';
                html += '<div class="skeleton shimmer skeleton-text" style="width: 60%"></div>';
                html += '<div class="skeleton shimmer skeleton-text" style="width: 40%"></div>';
                html += '</div>';
            }
            html += '</div></div></div>'; // end search-result-list

            html += '</div>'; // end search-result-contain
            return html;
        }

        /**
         * Log search intent to the REST API analytics endpoint.
         * Only called on definitive user actions (submit or click).
         */
        function logSearchIntent(query, source, resultsCount) {
            if (!query || query.length < 3) return;

            $.post(restBase + '/log', {
                query: query,
                source: source,
                results_count: resultsCount || 0,
            });
        }

        const debouncedSearch = debounce(performAjaxSearch, searchDebounceMs);
        const debouncedWarmSearch = debounce(performWarmSearch, 175);

        $("#s-two").on("keyup click", function (e) {
            // Don't trigger on spacebar — let the debounce handle it naturally
            if (e.type === 'keyup' && e.key === ' ') return;

            const value = $(this).val().trim();
            if (value.length > 0) {
                $("#clear-search-two").show();
            } else {
                $("#clear-search-two").hide();
            }
            if (value.length > 2) {
                if (searchCache[value]) {
                    $("#search-results-two").html(renderSearchResults(searchCache[value], value)).addClass("show");
                    if ($("#close-search-results-two").hasClass('hidden')) {
                        $("#close-search-results-two").removeClass('hidden');
                    }
                    lastResultsCount = searchCache[value].total_results || 0;
                } else {
                    debouncedSearch();
                }

                if (enableWarmJs && enableWarmApi && value.length > 3) {
                    debouncedWarmSearch();
                }
            } else {
                $("#search-results-two").removeClass("show");
                if (enableWarmJs && warmAjaxObj && typeof warmAjaxObj.abort === 'function') {
                    warmAjaxObj.abort();
                }
            }
        });

        // Clear search button (delegated for FontAwesome SVG replacement)
        $(document).on("click", "#clear-search-two", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("#s-two").val('').trigger('keyup').focus();
            $("#search-results-two").removeClass("show");
            $(this).hide();
        });

        // ── Intent-Based Logging: Hard Submit ──
        // Submit is logged server-side on the /search/ results page (templates/search.php),
        // where the result count is authoritative and race-free. Logging it here from the
        // shared `lastResultsCount` reported 0 whenever the user submitted before the
        // autocomplete request returned, so it is intentionally not done client-side.

        // ── Intent-Based Logging: Suggestion Click ──
        $(document).on("click", ".search-result-link", function () {
            const query = decodeURIComponent($(this).data('query') || '');
            const results = $(this).data('results') || 0;
            if (query) {
                logSearchIntent(query, 'click', results);
            }
        });

        function performAjaxSearch() {
            if ($(window).width() < 501) {
                $("body").addClass("lock");
            }
            var searchQuery = $("#s-two").val().trim();
            if (searchQuery.length > 2) {
                if ($("#close-search-results-two").hasClass('hidden')) {
                    $("#close-search-results-two").removeClass('hidden');
                }

                if (searchCache[searchQuery]) {
                    $("#search-results-two").html(renderSearchResults(searchCache[searchQuery], searchQuery)).addClass("show");
                    lastResultsCount = searchCache[searchQuery].total_results || 0;
                    return;
                }

                $("#search-results-two").html(renderSkeletonScreen()).addClass("show");
                $("#loading-indicator-two").hide();
                const requestToken = ++latestSearchToken;
                $.post(restBase + '/search', { query: searchQuery }, function (response) {
                    if (typeof response === 'string') {
                        try { response = JSON.parse(response); } catch (e) { }
                    }
                    let data = response.data || response;
                    if (data) {
                        // Spam kill command: the backend suppresses autocomplete for spam
                        // queries (dropdown-only). Don't cache or render — hide instead.
                        // The full search page still works for these queries.
                        if (data.spam === true || data.suppress_autocomplete === true) {
                            $("#search-results-two").removeClass("show").html('');
                            $("#loading-indicator-two").hide();
                            return;
                        }

                        searchCache[searchQuery] = data;
                        const currentQuery = $("#s-two").val().trim();
                        if (requestToken === latestSearchToken && currentQuery === searchQuery) {
                            lastResultsCount = data.total_results || 0;
                            $("#search-results-two").html(renderSearchResults(data, searchQuery)).addClass("show");
                        }
                    }
                    $("#loading-indicator-two").hide();
                }).fail(function (response) {
                    console.log(response);
                    $("#loading-indicator-two").hide();
                });

                $("#close-search-results-two").on("click", function () {
                    $("body").removeClass("lock");
                    $("#search-results-two").removeClass("show").html('');
                    $("#loading-indicator-two").hide();
                    $("#s-two").val('');
                    latestSearchToken++;
                    if (enableWarmJs && warmAjaxObj && typeof warmAjaxObj.abort === 'function') {
                        warmAjaxObj.abort();
                    }
                    $("#close-search-results-two").addClass('hidden');
                });
            } else {
                $("#loading-indicator-two").hide();
                $("#search-results-two").empty().removeClass("show");
            }
        }

        function performWarmSearch() {
            if (!enableWarmJs || !enableWarmApi) {
                return;
            }

            const searchQuery = $("#s-two").val().trim();
            if (searchQuery.length < 4) {
                return;
            }

            if (warmedPrefixes[searchQuery]) {
                return;
            }

            if (warmAjaxObj && typeof warmAjaxObj.abort === 'function') {
                warmAjaxObj.abort();
            }

            warmAjaxObj = $.post(restBase + '/warm', { query: searchQuery }, function (response) {
                if (typeof response === 'string') {
                    try { response = JSON.parse(response); } catch (e) { }
                }

                const data = response.data || response;
                warmedPrefixes[searchQuery] = true;

                if (data && Array.isArray(data.candidates)) {
                    data.candidates.forEach(candidate => {
                        if (typeof candidate === 'string' && candidate.length > 0) {
                            warmedPrefixes[candidate] = true;
                        }
                    });
                }
            }).fail(function (response, statusText) {
                if (statusText !== 'abort') {
                    console.log(response);
                }
            });
        }

        $(document).on("click", function (e) {
            if ($(window).width() > 500) {
                if (!$(e.target).closest("#search-form-two").length) {
                    $("#search-results-two").removeClass("show");
                    $("#loading-indicator-two").hide();
                    $("body").removeClass("lock");
                } else {
                    const value = $("#s-two").val().trim();
                    if ($("#search-results-two").text() !== '' && value.length > 2) {
                        $("#search-results-two").addClass("show");
                    }
                }
            }
        });
    });
});
